import React from 'react';
import VersionHistorySection from '../VersionHistorySection';
import { useEpdVersionHistoryDataOrWhileLoadingThenNull } from '../utils/EpdVersionHistoryDataContext';
import { VersionHistorySummaryGridSkeleton } from '../VersionHistorySummaryGrid';
import SystemBoundaryGridPdf from '../../grids/system-boundary/SystemBoundaryGridPdf';
import VersionHistorySystemBoundaryGrid from './VersionHistorySystemBoundaryGrid';
import SmartLabel from 'components/v2/labels/SmartLabel';
import { ImagesUpload } from 'components/v2/images-upload';

const VersionHistorySystemBoundarySection: React.FC<{}> = () => {
  const data = useEpdVersionHistoryDataOrWhileLoadingThenNull();

  return (
    <VersionHistorySection title="System boundary">
      {data ? (
        <>
          <SystemBoundaryGridPdf
            epdVersionId={data.epdVersionId}
            productType={data.epdDefinitionInformation.productType}
            dontApplyPrintStyles
          />
          <VersionHistorySystemBoundaryGrid data={data} />

          {data.systemBoundary?.processFlowDiagramsImages && data.systemBoundary.processFlowDiagramsImages.length > 0 && (
            <div>
              <SmartLabel label="Process flow diagram(s) related images" />
              <ImagesUpload
                name="ProcessFlowDiagramsImages"
                images={data.systemBoundary.processFlowDiagramsImages}
                onUpload={() => {}}
                onReorder={() => {}}
                onRemove={() => {}}
                disabled
                preferEnabledAppearanceEvenWhenDisabled
              />
            </div>
          )}
        </>
      ) : (
        <>
          <VersionHistorySummaryGridSkeleton skeletonRowsCount={8} />
          <VersionHistorySummaryGridSkeleton skeletonRowsCount={2} />
        </>
      )}
    </VersionHistorySection>
  );
};

export default VersionHistorySystemBoundarySection;
